module.exports = __webpack_public_path__ + "img/sprite.be8ef52a.png";